import React, { Component } from 'react';

import APIDocsCurl from 'common/developers/docs/api/APIDocsCurl';
import APIDocsMethod from 'common/developers/docs/api/APIDocsMethod';
import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsDeleteCompanyBlock extends Component {
  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">Delete company</div>
          <div className="text">Deletes a company.</div>
          <APIDocsTable
            title="Arguments"
            rows={[
              {
                description: 'Your secret API key.',
                heading: 'apiKey',
                subheading: 'string',
              },
              {
                description: 'The identifier you used when creating the company.',
                heading: 'companyID',
                subheading: 'string',
              },
            ]}
          />
          <div className="subheading">Returns</div>
          <div className="text">Returns "success" if the company was successfully deleted.</div>
        </div>
        <div>
          <div className="text">Endpoint</div>
          <Highlight lang="http">https://canny.io/api/v1/companies/delete</Highlight>
          <APIDocsMethod />
          <APIDocsCurl
            path="https://canny.io/api/v1/companies/delete"
            body={`\\
    -d apiKey=YOUR_API_KEY \\
    -d companyID=company1"`}
          />
          <div className="text">Example Response</div>
          <Highlight lang="json">success</Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
